<div class="data-label-container">
  <div class="label">{{ label }}</div>
  <div class="value">{{ value }}</div>
</div>
